import { render, staticRenderFns } from "./FilterStrip.vue?vue&type=template&id=e2c6cb70&scoped=true&"
import script from "./FilterStrip.vue?vue&type=script&lang=js&"
export * from "./FilterStrip.vue?vue&type=script&lang=js&"
import style0 from "./FilterStrip.vue?vue&type=style&index=0&id=e2c6cb70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c6cb70",
  null
  
)

export default component.exports